import { render, staticRenderFns } from "./BulkIssueStateBanner.vue?vue&type=template&id=8f1bc7b8&scoped=true"
import script from "./BulkIssueStateBanner.vue?vue&type=script&lang=js"
export * from "./BulkIssueStateBanner.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueStateBanner.vue?vue&type=style&index=0&id=8f1bc7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1bc7b8",
  null
  
)

export default component.exports